<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="title">Acknowledgments</h1>
<p class="p">We are indebted to the generosity of many postcard collectors who graciously shared their collections with us. Some are friends we have known for a long time (and bid against at auctions). Others are people we had never before met but who answered our call for postcards. Still others include eBay sellers who e-mailed us scans of cards when we somewhat sheepishly asked. Thank you to the following people, institutions, and organizations: Academy of Hoosier Heritage, Robert Barnard, Nancy Bennett, Del Chafey, Michael Gorham, Kevin Kent, Bill Kirk, Pam Lanham, Morgan County Historic Preservation Society, Morgan County Public Library, Tim and Camilla Morris, Elmer and Viola Reynolds, Joe Seiter, Keith Steinway, Bob Strader, Joanne Raetz Stuttgen, Bruce and Virginia Throckmorton, Curtis Tomak, and Jim Whitaker.</p>
<p class="p-indent">Furthermore, we are beholden to the following local residents, historians, and organizations whose passion for and commitment to preserving and recording the past have enriched this book immeasurably: Albert “Dutch” Allen, Wanda Allen, Kimberly Bright, Harry Brown, Alice Burns, Sam Cline, Dale Drake, Charles Finney, Alma Fraker, Mae Kivett Gano, Richard Hamilton, Becky Hardin, John E. Hurt Sr., Lloyd James, Virginia “Gin” Lewis, Morgan County Historic Preservation Society, Morgan County History and Genealogy Association, Bette Nunn, Elmer Reynolds, Lucille Sadler, Margaret Sedwick, and Phyllis Walker.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781439635179_aknow.vue?7fd4edb8